import { useTranslation } from "react-i18next";
import styles from "./styles.module.scss";

export const ColorPicker = ({ value, onChange, options }) => {
  const { colors = [], required = false } = options || {};
  const { t } = useTranslation("global");

  return (
    <div className={styles.colorPickerContainer}>
      <label className={styles.colorLabel}>{t("calendar.groups.color")}</label>
      <div
        className={styles.wrapper}
        role="radiogroup"
        aria-label="Color Picker"
      >
        {colors.map((color) => (
          <button
            key={color}
            type="button"
            className={`${styles.swatch} ${
              value === color ? styles.active : ""
            }`}
            style={{ backgroundColor: color }}
            onClick={() => onChange(color)}
            aria-checked={value === color}
            role="radio"
          >
            {value === color && <span className={styles.checkmark}>✓</span>}
          </button>
        ))}
        {required && !value && <span className={styles.error}>*</span>}
      </div>
    </div>
  );
};

export default ColorPicker;
